export default "__VITE_ASSET__B3uC1iHo__"